import * as React from 'react';
import {useState} from 'react';
import { Grid, Typography,FormControl, NativeSelect, InputBase } from '@material-ui/core';
import { makeStyles} from '@material-ui/core/styles'
import { Theme,withStyles,createStyles } from '@material-ui/core/styles';
import { TextBar } from 'src/components/sub-components/TextBar';
import { primaryBlue, primaryGray, searchBarBorderColor } from 'src/components/sub-components/colors/colors';
import Dropzone from 'react-dropzone';
import { UploadFile } from 'src/components/sub-components/UploadFile';

export function Step1(props) {
    const classes = useStyles()

    const [versionError,setVersionError]=useState({error:false, errorMsg:""})

    return (
        <Grid container className={classes.container}>
            <Grid item xs={6} md={6} style={{textAlign:"left",marginBottom:"20px"}}>

                <Typography className={classes.label}>Product Type</Typography>
                <FormControl className={classes.input}>
                <NativeSelect
                  id="demo-customized-select-native"
                //   value={selectedCoperate}
                  className={classes.input}
                //   onChange={changeCoperate}
                  input={<BootstrapInput/>}
                >
                <option value="test1">Test 1</option>
                <option value="test2">Test 2</option>
                </NativeSelect>
              </FormControl>
            </Grid>

            <Grid item xs={6} md={6} style={{textAlign:"left",marginBottom:"20px"}}>
                <Typography style={{marginLeft:"35px"}} className={classes.label}>Version</Typography>
                <TextBar error={versionError} width="100%"/>
            </Grid>

            <Grid item xs={6} md={6} style={{textAlign:"left",marginBottom:"20px"}}>

                <Typography className={classes.label}>Device Category</Typography>
                <FormControl className={classes.input}>
                <NativeSelect
                  id="demo-customized-select-native"
                //   value={selectedCoperate}
                  className={classes.input}
                //   onChange={changeCoperate}
                  input={<BootstrapInput/>}
                >
                <option value="test1">Test 1</option>
                <option value="test2">Test 2</option>
                </NativeSelect>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={12} style={{textAlign:"left"}}>
                <Typography className={classes.label}>Upload Bin file</Typography>
            </Grid>
            <Grid item xs={12} md={12}>
            <Dropzone onDrop={acceptedFiles => console.log(acceptedFiles)}>
              {({getRootProps, getInputProps}) => (
                <section>
                  <div {...getRootProps()} style={{border:"1px dashed rgba(117, 117, 117, 0.5)",backgroundColor:"#EDEDED", borderRadius:"8px", height:"150px",padding:"40px"}}>
                    <input {...getInputProps()} />
                    <UploadFile/>
                    <Typography>
                      <span style={{fontSize:"15px",color:primaryGray}}>Drag & Drop file here to upload or </span>
                      <span style={{fontSize:"15px",color:primaryBlue}}>Browse</span>
                    </Typography>
                    
                  </div>
                </section>
              )}
            </Dropzone>
            </Grid>

        </Grid>
    )
}

const useStyles = makeStyles((theme:Theme) => ({
    container:{
        paddingTop:"20px"
    },
    input:{
      width:"100%",
      height:"40px",
      backgroundColor:"#F4F5F7",
    },
    label:{
        fontSize:"15px",
        color:primaryGray,
        paddingBottom:"5px"
    }
}));

const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: "white",
      border: '1px solid #ced4da',
      fontSize: 16,
      padding: '10px 26px 10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:focus': {
        borderRadius: 4,
        borderColor: searchBarBorderColor,
        backgroundColor: "white",
      },
    },
  }),
)(InputBase);